import { render } from "./modalRejectProposal.vue?vue&type=template&id=1a4c35b1&scoped=true"
import script from "./modalRejectProposal.vue?vue&type=script&lang=js"
export * from "./modalRejectProposal.vue?vue&type=script&lang=js"

import "./modalRejectProposal.vue?vue&type=style&index=0&id=1a4c35b1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4c35b1"]])

export default __exports__